import { Colors } from "../../utils/colors";
import { Icon } from "@iconify/react";
import { isDesktop } from "react-device-detect";
import { HorizontalDivider } from "../Dividers/HorizontalDivider";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import ExploreNavCard from "../../components/Explore/ExploreNavCard";
import TechCategory from "../../assets/ExplorePageBackgrounds/TechCategory.png";
import InfluencersCategory from "../../assets/ExplorePageBackgrounds/InfluencersCategory.png";
import EntertainmentCategory from "../../assets/ExplorePageBackgrounds/EntertainmentCategory.png";
import ArtistsCategory from "../../assets/ExplorePageBackgrounds/ArtistsCategory.png";

const ExploreCategories = () => {
  const navigate = useNavigate();

  const styles = {
    title: {
      fontSize: isDesktop ? 32 : 24,
      fontWeight: 600,
    },
  };

  return (
    <div>
      <div
        className="ColumnNormal"
        style={{ gap: isDesktop ? 7 : 4, marginBottom: 24 }}
      >
        <div className="AlignedRow" style={{ gap: 14 }}>
          <span style={styles.title}>Browse by Category</span>
          <Icon
            icon="ion:file-tray-full"
            height={30}
            style={{ color: Colors.BLACK }}
          />
        </div>
        <span className="bodySubtext">
          Browse creators, brands, and businesses by category
        </span>
      </div>
      <HorizontalDivider altMargin={isDesktop ? 30 : 24} />
      <div
        className="AlignedRow EventCategoriesContainer"
        style={{ gap: 14, flexWrap: "wrap" }}
      >
        <ExploreNavCard
          title="Artists"
          onPress={() => navigate("/explore/artists")}
          src={ArtistsCategory}
        />
        <ExploreNavCard
          title="Influencers"
          onPress={() => navigate("/explore/influencers")}
          src={InfluencersCategory}
        />
        <ExploreNavCard
          title="Entertainment"
          onPress={() => navigate("/explore/entertainment")}
          src={EntertainmentCategory}
        />
        <ExploreNavCard
          title="Tech"
          onPress={() => navigate("/explore/tech")}
          src={TechCategory}
        />
      </div>
    </div>
  );
};

export default memo(ExploreCategories);
